import { Navigate } from "react-router-dom";
import { useRole } from "./RoleContext";
import { toast } from "react-toastify";
import Loading from "./Templates/Loading";

const ProtectedRoute = ({ allowedRoles, children }) => {
  const { role } = useRole();

  // Check if the token or relevant auth info exists in localStorage
  const token = localStorage.getItem("token"); // Replace 'authToken' with the correct key

  // If no token is found in localStorage, redirect to the login page
  if (!token) {
    // console.log("No authentication token found, redirecting to login.");
    return <Navigate to="/" />;
  }

  // Check if the role is still being fetched
  if (!role) {
    // console.log("Role not available yet");
    return <div><Loading></Loading></div>; // Show a loading spinner while role is being fetched
  }

  // Check if the current role is in the list of allowed roles
  const isAuthorized = allowedRoles.includes(role);

  // A user hitting a forbidden route directly (e.g. typing /main/project-list)
  // is bounced back to the board rather than left on a blank page.
  if (!isAuthorized) {
    toast.warning("You are not allowed to access this page");
    return <Navigate to="/main/board" replace />;
  }

  return children;
};

export default ProtectedRoute;
